"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimesheetCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const schedule_1 = require("@bemlo/schedule");
const constants_1 = require("../constants");
const Badge_1 = require("../elements/Badge");
const Clickable_1 = require("../elements/Clickable");
const Flex_1 = require("../elements/Flex");
const useShiftCardColors_1 = require("../elements/ShiftCard/useShiftCardColors");
const Text_1 = require("../elements/Text");
const translate_1 = require("../translate");
const StyledClickable = (0, styled_1.default)(Clickable_1.Clickable)({
    display: 'flex',
    boxShadow: constants_1.theme.boxShadow.normal,
    borderRadius: constants_1.theme.border.radius.normal,
    backgroundColor: constants_1.Color.WHITE,
    '&:hover': {
        filter: 'brightness(98%)',
    },
    '&:active': {
        filter: 'brightness(95%)',
    },
});
const LEFT_BORDER_WIDTH = constants_1.theme.border.radius.normal;
const colors = useShiftCardColors_1.STATUS_COLOR_MAP[enums_1.DynamicShiftStatus.BOOKED];
const StatusBorder = styled_1.default.div({
    borderBottomLeftRadius: constants_1.theme.border.radius.normal,
    borderTopLeftRadius: constants_1.theme.border.radius.normal,
    backgroundColor: colors.text,
    width: LEFT_BORDER_WIDTH,
});
const Left = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: `1px solid ${colors.borderOuter}`,
    borderBottom: `1px solid ${colors.borderOuter}`,
    borderRight: `1px solid ${colors.borderInner}`,
    width: 50,
    backgroundColor: colors.background,
    color: colors.text,
});
const Right = styled_1.default.div({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: constants_1.theme.spacing[1],
    borderTop: constants_1.theme.border.style.thin,
    borderRight: constants_1.theme.border.style.thin,
    borderBottom: constants_1.theme.border.style.thin,
    borderTopRightRadius: constants_1.theme.border.radius.normal,
    borderBottomRightRadius: constants_1.theme.border.radius.normal,
    padding: constants_1.theme.spacing[3],
    overflow: 'hidden',
});
const TimeRow = styled_1.default.div({
    display: 'flex',
    alignItems: 'center',
    gap: constants_1.theme.spacing[3],
    containerType: 'inline-size',
});
const TimeText = (0, styled_1.default)(Text_1.Text) `
  @container (max-width: 300px) {
    font-size: ${constants_1.theme.font.size[5]}px;
  }
`;
const TimesheetCard = ({ className, timesheet, pricing, onClick, }) => {
    const t = (0, translate_1.useTranslations)();
    const duration = (0, schedule_1.shiftWorkDuration)({
        startTime: timesheet.startDateTime.format('HH:mm'),
        endTime: timesheet.endDateTime.format('HH:mm'),
        breakTime: timesheet.breakTime,
        date: timesheet.startDateTime.format('YYYY-MM-DD'),
        onCallTime: null,
    }).shift;
    return ((0, jsx_runtime_1.jsxs)(StyledClickable, { className: className, onClick: onClick, children: [(0, jsx_runtime_1.jsx)(StatusBorder, {}), (0, jsx_runtime_1.jsxs)(Left, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, { size: 5, children: timesheet.startDateTime.format('MMM').toUpperCase() }), (0, jsx_runtime_1.jsx)(Text_1.Text, { size: 2, fontWeight: constants_1.theme.font.weight.bold, children: timesheet.startDateTime.date() })] }), (0, jsx_runtime_1.jsxs)(Right, { children: [(0, jsx_runtime_1.jsxs)(TimeRow, { children: [(0, jsx_runtime_1.jsxs)(TimeText, { size: 3, fontWeight: constants_1.theme.font.weight.bold, children: [timesheet.startDateTime.format('ddd'), ",", ' ', timesheet.startDateTime.formatTimeRange(timesheet.endDateTime)] }), (0, jsx_runtime_1.jsx)(Text_1.Text, { color: constants_1.Color.MEDIUM_BLUE, size: 5, children: t.$date.formatDuration({ hours: duration.asHours() }) })] }), (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 2, items: "end", children: [(0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 1, styles: { overflow: 'hidden' }, children: [(0, jsx_runtime_1.jsxs)(Text_1.Text, { size: 6.5, fontWeight: constants_1.theme.font.weight.bold, color: constants_1.Color.DARKER_GREY, noWrap: true, children: [timesheet.shift.scheduleResource?.name && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [timesheet.shift.scheduleResource?.name, "\u00A0\u00A0\u2022\u00A0\u00A0"] })), timesheet.shift.unit.name] }), (0, jsx_runtime_1.jsx)(Text_1.Text, { size: 6.5, color: constants_1.Color.DARK_GREY, noWrap: true, children: timesheet.shift.unit.address })] }), pricing && ((0, jsx_runtime_1.jsx)(Badge_1.Badge, { styles: { ml: 'auto' }, size: "sm", children: pricing }))] })] })] }));
};
exports.TimesheetCard = TimesheetCard;
